'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

var _disclosure = require('./disclosure');

var _disclosure2 = _interopRequireDefault(_disclosure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MinimumInvestmentsCard = function (_React$Component) {
  _inherits(MinimumInvestmentsCard, _React$Component);

  function MinimumInvestmentsCard() {
    _classCallCheck(this, MinimumInvestmentsCard);

    return _possibleConstructorReturn(this, (MinimumInvestmentsCard.__proto__ || Object.getPrototypeOf(MinimumInvestmentsCard)).apply(this, arguments));
  }

  _createClass(MinimumInvestmentsCard, [{
    key: 'renderValue',
    value: function renderValue(value) {

      if ((0, _ramda.isNil)(value) || -2 === parseInt(value, 10) || 0 === parseInt(value, 10)) {
        return "No Minimum";
      } else if (-1 === parseInt(value, 10)) {
        return "Minimum may be waived";
      } else if (-3 === parseInt(value, 10)) {
        return "This class is available for investment in Japan ONLY";
      }

      value = Math.floor(value);
      var currency = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'MINIMUM_INVESTMENTS_USD_ONLY') ? 'USD ' : _currency_utility2.default.getCurrencyMapping(this.props.currencyCode, this.props.country);

      if (value >= 1000000) {
        var formattedValueObj = _currency_utility2.default.convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue(value);
        var formattedAmount = _react2.default.createElement(_formatted_number2.default, { value: formattedValueObj.value, numberFormat: this.props.numberFormat });

        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: formattedValueObj.translationKey,
          defaultMessage: '-',
          values: { amount: formattedAmount, currency: currency, role: this.props.role } });
      } else {
        return _react2.default.createElement(_formatted_number2.default, { value: currency + _number_utility2.default.convertToNumberWithCommas(value), numberFormat: this.props.numberFormat });
      }
    }
  }, {
    key: 'renderSubHeader',
    value: function renderSubHeader() {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'MINIMUM_INVESTMENTS_HIDE_SUBHEADERS')) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'row margin-all-0 padding-vertical-5 border-bottom-1 border-card-title-border' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 col-lg-12 col-xlg-12 padding-horizontal-24' },
          _react2.default.createElement(
            'div',
            { id: 'regular-header', className: 'tag' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-minimum-investments-regular-sub-header', defaultMessage: '' })
          )
        )
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      return _react2.default.createElement(
        'div',
        { className: 'margin-horizontal--30' },
        _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'MINIMUM_INVESTMENTS_IRA') && _react2.default.createElement(
          'div',
          { 'data-testid': 'minimum-investments-ira', role: "table", 'aria-labelledby': "minimum-investments-header ira-header" },
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5 border-bottom-1 border-card-title-border', role: "row" },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-xlg-12 padding-horizontal-24' },
              _react2.default.createElement(
                'div',
                { id: 'ira-header', className: 'tag', role: "cell" },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-minimum-investments-ira-sub-header', defaultMessage: '' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5 border-bottom-1 border-card-title-border', role: "row" },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-xlg-12 padding-horizontal-24 ' },
              _react2.default.createElement(
                'span',
                { className: 'text-left col-md-7 col-lg-7 col-xlg-7 font-light category', role: "rowheader" },
                'Minimum Investment'
              ),
              _react2.default.createElement(
                'span',
                { className: 'text-right col-md-5 col-lg-5 col-xlg-5 float-right font-light category',
                  'data-testid': 'ira-minimum-investments', role: "cell" },
                this.renderValue(this.props.minimumInvestments.iraInvestments)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5 border-bottom-1 border-card-title-border', role: "row" },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-xlg-12 padding-horizontal-24' },
              _react2.default.createElement(
                'span',
                { className: 'text-left col-md-7 col-lg-7 col-xlg-7 font-light category', role: "rowheader" },
                'Subsequent Investment'
              ),
              _react2.default.createElement(
                'span',
                { className: 'text-right col-md-5 col-lg-5 col-xlg-5 float-right font-light category',
                  'data-testid': 'ira-subsequent-investments', role: "cell" },
                this.renderValue(this.props.minimumInvestments.iraSubsequentInvestments)
              )
            )
          )
        ),
        _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'MINIMUM_INVESTMENTS_REGULAR') && _react2.default.createElement(
          'div',
          { 'data-testid': 'minimum-investments-regular', role: "table", 'aria-labelledby': "minimum-investments-header regular-header" },
          this.renderSubHeader(),
          _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-vertical-5 border-bottom-1 border-card-title-border', role: "row" },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-xlg-12 padding-left-0 padding-right-0 padding-horizontal-24' },
              _react2.default.createElement(
                'span',
                { className: 'text-left col-md-7 col-lg-7 col-xlg-7 category', role: "rowheader" },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-minimum-investments-initial-investment-label',
                  defaultMessage: 'Minimum Investment' })
              ),
              _react2.default.createElement(
                'span',
                { className: 'text-right col-md-5 col-lg-5 col-xlg-5 float-right font-light category',
                  'data-testid': 'regular-minimum-investments', role: "cell" },
                this.renderValue(this.props.minimumInvestments.regularInvestments),
                _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'MINIMUM_INVESTMENTS_OR_EQUIVALENT') && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-minimum-investments-initial-investment-equivalent', defaultMessage: ' or equivalent' })
              )
            )
          ),
          !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'HIDE_REGULAR_SUBSEQUENT_INVESTMENTS') && _react2.default.createElement(
            'div',
            { className: 'row margin-all-0 padding-top-5' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-xlg-12 padding-left-0 padding-right-0 padding-horizontal-24', role: "row" },
              _react2.default.createElement(
                'span',
                { className: 'text-left col-md-7 col-lg-7 col-xlg-7 category', role: "rowheader" },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-minimum-investments-subsequent-investment-label',
                  defaultMessage: 'Subsequent Investment' })
              ),
              _react2.default.createElement(
                'span',
                { className: 'text-right col-md-5 col-lg-5 col-xlg-5 float-right category',
                  'data-testid': 'regular-subsequent-investments', role: "cell" },
                this.renderValue(this.props.minimumInvestments.regularSubsequentInvestments)
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderBelgiumDisclosure',
    value: function renderBelgiumDisclosure(disclosure) {
      return _react2.default.createElement(_disclosure2.default, {
        disclosureText: disclosure,
        shouldAlwaysShowMore: true,
        placementId: 'pdpCardMinimumInvestmentBelgium'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var renderMinimumInvestmentDisclosure = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_MINIMUM_INVESTMENT_DISCLOSURE') && (this.props.language === 'fr' || this.props.language === 'nl');

      if (renderMinimumInvestmentDisclosure && (0, _ramda.isNil)(this.props.disclosure)) {
        return null;
      }

      return _react2.default.createElement(
        _card_component2.default,
        {
          className: 'print-full-width',
          headerTitle: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-overview-minimum-investments-header', defaultMessage: 'Minimum Investments' }),
          headerTitleId: "minimum-investments-header",
          headerTitleLabel: "",
          headerLabel: "",
          displayStyle: 'width-percent-100',
          breakpoint: this.props.breakpoint,
          is25PercentCard: true,
          noPadding: false
        },
        renderMinimumInvestmentDisclosure ? this.renderBelgiumDisclosure(this.props.disclosure) : this.renderContent()
      );
    }
  }]);

  return MinimumInvestmentsCard;
}(_react2.default.Component);

exports.default = MinimumInvestmentsCard;